import { Component, computed, input } from '@angular/core';
import { ProjectPublicResponse } from '@app/models/project.models';
import { CardComponent } from '@app/ui-components/card/card.component';
import { InfoLabelComponent } from '@app/ui-components/info-label/info-label.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-project-details-section-c',
  imports: [CardComponent, InfoLabelComponent, TranslateModule],
  templateUrl: './project-details-section-c.component.html',
  styleUrl: './project-details-section-c.component.scss',
})
export class ProjectDetailsSectionCComponent {
  projectDetails = input.required<ProjectPublicResponse>();
  protected translationKey = 'projectDetails.sectionC.';
  protected riskFactorsText = computed(
    () => this.projectDetails().riskFactors ?? ''
  );
  protected riskFactorsLength = computed(
    () => this.riskFactorsText().length
  );
}
